import { Button } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const ExtraLargeButton = styled(Button)`
  width: 16rem;
`;
